import axios from "axios";
import { getVisitorId } from "@/lib/visitorTracker";

const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.NEXT_PUBLIC_API_END_POINT,
});

// Signup calls carry the website visitor id, so the API can tie the new
// account to the visits that led to it (SA → Visitor Analytics).
instance.interceptors.request.use((config) => {
  if (/^\/?api\/(register|businesses\/verify\/)/.test(config.url || "")) {
    const visitorId = getVisitorId();
    if (visitorId) config.headers["X-Visitor-Id"] = visitorId;
  }
  return config;
});

export default instance;
